/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Card from '../../Reusable/Card';
import { LanguageContext } from '../../../../../libs/Context';
import { useNavigate } from 'react-router-dom';
import { getBookmarks } from '../../../../actions/feeds_actions_new';
import { useSelector } from 'react-redux';
import './bookmark.css';
import { feedActionContext } from '../../..';

const BookMarks = (props) =>
{
	const { count, setSelectedFilter } = props;
	const [ bookmarkCount, setBookmarkCount ] = useState(count);
	const [ expanded, setExpanded ] = useState('panel1');
	const { language } = useContext(LanguageContext);
	const [ bookmarkList, setBookmarkList ] = useState<any>([]);
	const navigate = useNavigate();
	const userData = useSelector((state:any) => state.mysession.session);
	const { feedAction, handleFeedAction } = useContext(feedActionContext);
	const itemPerPage = 3;

	const toggleShowMore = (e) =>
	{
		e.stopPropagation();
		setSelectedFilter((prevFilter) => (Object.keys(prevFilter)?.length ? {} : prevFilter));
		navigate('/news/bookmarks');
	};
	const handleChange = (panel) => (event, isExpanded) =>
	{
		setExpanded(isExpanded ? panel : false);
	};

	const getBookmarkList = async () =>
	{
		const query = {
			skip    : 0,
			limit   : itemPerPage,
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role

		};

		try
		{
			const res = await getBookmarks(query);

			if (res?.status)
			{
				setBookmarkList(res?.data?.bookmarks);
			}
		}
		catch (err)
		{
			// catchErr(err);
			// eslint-disable-next-line no-console
			console.error('err');
		}
	};

	const increaseCount = () =>
	{
		setBookmarkCount(bookmarkCount + 1);
	};
	const decreaseCount = () =>
	{
		setBookmarkCount(bookmarkCount - 1);
	};

	useEffect(() =>
	{
		getBookmarkList();
	}, [ ]);

	useEffect(() =>
	{
		if (feedAction?.bookmark_add || feedAction?.bookmark_remove || feedAction?.edit_feed || feedAction?.remove_feed)
		{
			getBookmarkList();
			if (feedAction?.bookmark_add)
			{
				handleFeedAction('remove', 'bookmark_add');
				increaseCount();
			}
			else if (feedAction?.bookmark_remove)
			{
				handleFeedAction('remove', 'bookmark_remove');
				decreaseCount();
			}
			else if (feedAction?.edit_feed)
			{
				handleFeedAction('remove', 'edit_feed');
			}
			else if (feedAction?.remove_feed)
			{
				feedAction?.remove_feed?.bookMark && decreaseCount();
				handleFeedAction('remove', 'remove_feed');
			}
		}
		else if (feedAction?.report_tag && bookmarkList?.length > 0)
		{
			const filteredList = bookmarkList?.filter((each) => each?.feedId !== feedAction?.report_tag?._id);

			setBookmarkList(filteredList);
			decreaseCount();
		}
	}, [ feedAction?.bookmark_add, feedAction?.bookmark_remove, feedAction?.edit_feed, feedAction?.remove_feed, feedAction?.report_tag ]);

	if (bookmarkCount <= 0 && bookmarkList?.length === 0) return <></>;

	return (
		<Grid item width='100%' mb={2}>
			<Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} sx={{ width: 'var(--percent100)', borderRadius: '13px !important', overflow: 'hidden', margin: '0' }}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />} className='helpSupSummary'
					sx={{
						padding          : '24px 16px',
						'&.Mui-expanded' : {
							minHeight : '44px'
						},
						'& .MuiAccordionSummary-expandIconWrapper' : {
							marginLeft : '10px'
						}
					}}
				>
					<Grid container flexWrap='nowrap'>
						<Grid item xs sx={{ minWidth: 0, overflow: 'hidden' }} display={'flex'} alignItems={'center'}>
							<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
								<Typography variant='body1' fontWeight='var(--font500)'>{language?.bookmark} ({bookmarkCount})</Typography>
							</Box>
						</Grid>
						<Grid item sx={{ flexShrink: 0 }} display={'flex'} alignItems='center'>
							{/* <Typography color='primary' variant='body2' fontWeight='var(--font500)' onClick={toggleShowMore} sx={{ cursor: 'pointer' }}>{ 'View all'}</Typography> */}
							<Typography
								color='primary'
								variant='body2'
								fontWeight='var(--font500)'
								onClick={bookmarkCount > 0 ? toggleShowMore : undefined}
								sx={{ cursor: bookmarkCount >= 3 ? 'pointer' : 'default' }}
							>
								{bookmarkCount >= 3 ? language.viewAll : ''}
							</Typography>

						</Grid>
					</Grid>
				</AccordionSummary>
				<AccordionDetails sx={{ padding: '0 4px' }}>
					<Grid container>
						{bookmarkList?.map((item:any, index) => (
							<Grid item xs={12} key={`${item?._id}unique${index}`} >
								<Card
									item={item}
									key={item?._id}
									showBookmarkButton
									borderstyle='none'
									borderBtm={index === bookmarkList.length - 1 ? 'none' : '1px solid var(--share)'}
									bordeRadius='none'
								/>
							</Grid>
						))}
					</Grid>
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
};

export default BookMarks;
